import React, { Component } from 'react'
import * as R from 'ramda'
import HoverInfo from '../../UniformComponents/HoverInfo'

import './styles/checkbox.scss'

class Checkbox extends Component {
    constructor(props) {
        super(props)

        if (typeof props.register === 'function') {
            props.register(props.name, this.validate)
        }
        this.state = {
            isInValid: false,
        }
    }

    componentWillUnmount() {
        const { unregister, name } = this.props

        if (typeof unregister === 'function') {
            unregister(name)
        }
    }

    validate = ({ value, name }) => {
        const { isMandatory, validate } = this.props

        const hasValue = !R.and(R.isNil, R.isEmpty)(value)
        let isValid = !isMandatory || hasValue
        if (typeof validate === 'function') {
            isValid = isValid && validate({ value, name })
        }

        return isValid
    }

    onChange = (e) => {
        e.stopPropagation()

        const { name, onBlur } = this.props
        const { checked } = e.target

        this.setState({
            isInValid: !this.validate({ checked, name }),
        })

        if (typeof onBlur === 'function') {
            onBlur({ value: checked, name }, e)
        }
    }

    renderInput = () => {
        const {
            disabled, name, defaultChecked, placeholder, checked, valueid,
        } = this.props
        const { isInValid } = this.state

        let elem = ''

        if (!disabled) {
            elem = (
                <div className="check-wrap">
                    <input
                        type="checkbox"
                        name={name}
                        id={name}
                        className={`checkbox-input ${isInValid ? 'validation-error' : ''}`}
                        onChange={this.onChange}
                        defaultChecked={defaultChecked}
                        placeholder={placeholder}
                        checked={checked}
                        valueid={valueid}
                    />
                    <span className="custom-checkbox">
                        <i className="check-icon fa-regular fa-check" />
                    </span>
                </div>
            )
        } else if (defaultChecked) {
            elem = (
                <span className="checkbox-input">
                    <i className="fa-regular fa-check" />
                </span>
            )
        } else {
            elem = (
                <span className="check-wrap disabled">
                    <i
                        style={{ color: 'lightgrey', fontSize: 18 }}
                        className={`fa-regular ${checked ? 'fa-square-check' : 'fa-square'}`}
                    />
                </span>
            )
        }

        return elem
    }

    renderLabel = () => {
        const {
            name, label, labelStyle, labelDir,
            tooltipTitle, tooltipText, tooltipLinkLabel, tooltipLink, tooltipDir, disabled,
        } = this.props

        const Label = () => (
            <React.Fragment>
                <p dangerouslySetInnerHTML={{ __html: label }} />
                {tooltipText && (
                    <HoverInfo
                        cssClass="hover-info"
                        title={tooltipTitle}
                        desc={tooltipText}
                        linkText={tooltipLinkLabel}
                        href={tooltipLink}
                        dir={tooltipDir || 'right'}
                    >
                        <i className="info-icon fa-solid fa-circle-question" style={{ fontSize: 14 }} />
                    </HoverInfo>
                )}
            </React.Fragment>
        )
        if (!R.isEmpty(label) && !R.isNil(label)) {
            return (
                <label
                    htmlFor={name}
                    style={labelStyle}
                    className={`
                        checkbox-label 
                        ${labelDir === 'left' ? 'label-left' : ''}
                        ${disabled ? 'disabled' : ''}
                    `}
                >
                    <Label />
                </label>
            )
        }
        return null
    }

    render() {
        const {
            style, children, cssClass, labelDir, stopPropagation,
        } = this.props
        return (
            <div
                className={`form-checkbox ${cssClass || ''}`}
                style={style}
                onClick={(e) => { stopPropagation ? e.stopPropagation() : null }}
            >
                {labelDir === 'left' && this.renderLabel()}
                {this.renderInput()}
                {labelDir !== 'left' && this.renderLabel()}
                {children}
            </div>
        )
    }
}

export default Checkbox
